import { Link } from "react-router-dom";
import { useT } from "@/i18n/I18nContext";

export default function Footer() {
  const t = useT();
  return (
    <footer style={{ background: "var(--brand)" }} className="text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="font-display text-2xl font-black">Apex MVA Legal Group</div>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-white/70">
              {t("footer.about")}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {[
                t("footer.tag.ny"),
                t("footer.tag.nj"),
                t("footer.tag.no_fee"),
                t("footer.tag.spanish"),
              ].map((tag) => (
                <span key={tag} className="pill" style={{ background: "rgba(255,255,255,.06)", color: "white", borderColor: "rgba(255,255,255,.15)" }}>{tag}</span>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">{t("footer.action.title")}</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/intake" className="hover:text-[#E85D04]">{t("footer.action.intake")}</Link></li>
              <li><Link to="/find-care" className="hover:text-[#E85D04]">{t("nav.find_care")}</Link></li>
              <li><Link to="/estimator" className="hover:text-[#E85D04]">{t("footer.action.estimator")}</Link></li>
              <li><Link to="/chat" className="hover:text-[#E85D04]">{t("footer.action.chat")}</Link></li>
              <li><a href="tel:+18005551234" className="hover:text-[#E85D04]">{t("footer.action.call")}</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">{t("footer.legal.title")}</div>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>{t("footer.legal.advertising")}</li>
              <li>{t("footer.legal.no_guarantee")}</li>
              <li>{t("footer.legal.consult")}</li>
              <li><Link to="/admin/login" className="hover:text-[#E85D04]" data-testid="footer-admin-link">{t("footer.legal.admin")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/50 md:flex-row md:items-center">
          <div>© {new Date().getFullYear()} Apex MVA Legal Group. {t("footer.rights")}</div>
          <div>{t("footer.serving")}</div>
        </div>
      </div>
    </footer>
  );
}
